module.exports = __webpack_public_path__ + "media/images/bnr_special_event-c96a417bd8a4e140a6703810a85eef8c.jpg";